window.$MIDE_CONFIG = {
    /* API根路径 */
    apiUrlRoot: '',
    /* 资源根路径 */
    resourceUrlRoot: '',
};

switch (process.env.VUE_APP_BUILD) {
case 'PRODUCTION':
    /* 生产环境 */
    window.$MIDE_CONFIG.apiUrlRoot = 'https://parent-service.midevip.com';
    window.$MIDE_CONFIG.resourceUrlRoot = 'https://f.midevip.com';
    break;
case 'TEST':
    /* 测试环境 */
    window.$MIDE_CONFIG.apiUrlRoot = 'https://parent-service.midevip.com';
    window.$MIDE_CONFIG.resourceUrlRoot = 'https://f.midevip.com';
    break;
case 'K8S':
    /* 测试环境 */
    window.$MIDE_CONFIG.resourceUrlRoot = 'https://filedev2.midevip.com';
    break;
default:
    /* 开发环境 */
    // window.$MIDE_CONFIG.apiUrlRoot = 'https://parent-service.midevip.com';
    // window.$MIDE_CONFIG.resourceUrlRoot = 'https://f.midevip.com';
    window.$MIDE_CONFIG.apiUrlRoot = 'https://parent-service.midevip.com';
    window.$MIDE_CONFIG.resourceUrlRoot = 'https://f.midevip.com';
    break;
}
